"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAxiosError = void 0;
var _axios = _interopRequireDefault(require("axios"));
/**
 * This is essentially a re-export of `isAxiosError` from the main axios package for convenience
 */
var isAxiosError = function isAxiosError(error) {
  return _axios.default.isAxiosError(error);
};

// re-exporting types so users don't have to consume axios directly
exports.isAxiosError = isAxiosError;
//# sourceMappingURL=axiosForwarding.js.map